import React from 'react';
import { InfoIcon, CheckIcon, LockIcon } from 'lucide-react';
import { safeguards } from '../../data/samplePrompts';
export function AiSafeguards() {
  return <div className="mx-auto mt-10 max-w-3xl space-y-6" data-id="element-149" data-mp="1gvbd9e3ntl9o">
      <div className="flex items-start gap-3 rounded-2xl border border-grape/30 bg-lilac-soft p-5" data-id="element-150" data-mp="1vowr2i3wyd8b">
        <InfoIcon className="mt-0.5 h-5 w-5 shrink-0 text-grape-deep" aria-hidden="true" data-id="element-151" data-mp="1qsg3pq4jg2wa" />
        <p className="text-sm leading-relaxed text-plum/80" data-id="element-152" data-mp="132lpp58hg8ag">
          <span className="font-bold text-plum" data-id="element-153" data-mp="y2h636ca2xg0">AI can assist with organization and drafting,</span> but it cannot
          independently verify every project detail or replace your professional judgment.
        </p>
      </div>

      <div className="rounded-2xl bg-plum p-6 text-white sm:p-8" data-id="element-154" data-mp="180dfntpkhkc0">
        <h3 className="flex items-center gap-2 font-display text-lg font-black sm:text-xl" data-id="element-155" data-mp="kb2nv1q730a0">
          <LockIcon className="h-5 w-5 shrink-0 text-grape-soft" aria-hidden="true" data-id="element-156" data-mp="k8q1mcdem3r5" />
          A method that keeps AI grounded in your real project
        </h3>
        <p className="mt-3 text-sm text-white/70" data-id="element-157" data-mp="5nzbr7udlnyl">Every prompt in the system follows one essential principle:</p>
        <p className="mt-2 font-display text-xl font-black leading-snug text-white sm:text-2xl" data-id="element-158" data-mp="9o9i4lm2ygdz">
          Never let AI invent requirements, prices, deadlines, or results you didn’t provide.
        </p>
        <p className="mt-4 text-sm text-white/70" data-id="element-159" data-mp="jf46pwmsts2l">The prompts include instructions that help you:</p>
        <ul className="mt-3 grid gap-2.5 sm:grid-cols-2" data-id="element-160" data-mp="3ix3q4ybjk5vf">
          {safeguards.map(s => <li key={s} className="flex items-start gap-2 text-sm text-white/90" data-id="element-161" data-mp="3mww11hoeqo3y">
              <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-grape-soft" strokeWidth={3} data-id="element-162" data-mp="3ru49gqjr7ds0" />
              {s}
            </li>)}
        </ul>
      </div>
    </div>;
}